import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { NX_MODAL_DATA, NxModalRef } from '@aposin/ng-aquila/modal';
import { Subscription } from 'rxjs';
import { ModalValidationData } from '../../interfaces/forms/privacy-data';
import { PrivacyService } from '../../services/privacy/privacy.service';
import { ScrollProgressService } from '../../services/scroll-progress/scroll-progress.service';

@Component({
    selector: 'app-modal-form',
    templateUrl: './modal-form.component.html',
    styleUrls: ['./modal-form.component.scss'],
    standalone: false
})
export class ModalFormComponent implements OnInit, OnDestroy {
  disabled: boolean = true;

  scrollSubscription!: Subscription;

  constructor(
    @Inject(NX_MODAL_DATA) public data: ModalValidationData,
    private scrollProgressService: ScrollProgressService,
    private privacyService: PrivacyService,
    private modal: NxModalRef<ModalFormComponent>
  ) {}

  ngOnInit(): void {
    this.scrollSubscription = this.scrollProgressService
      .getScroll()
      .subscribe((res) => {
        this.disabled = res < 1;
      });
  }

  onClick() {
    this.privacyService.setPrivacyRead(true);
    this.modal.close(true);
  }

  ngOnDestroy() {
    this.scrollSubscription.unsubscribe();
  }
}
